export const KidsRecoSliderData = [
  {
    id: 1,
    src: '/images/Kids/camera.jpg',
    alt: 'list-img',
    title: '엄마, 찰칵찰칵!',
    rate: '4.3',
    intro: '아이들의 눈으로 아름답고 깨끗한 세상을 담다!',
  },
  {
    id: 2,
    src: '/images/Kids/colorPencil.jpg',
    alt: 'list-img',
    title: '쓱삭쓱삭, 드로잉',
    rate: '3.1',
    intro: '형형색색의 색연필로 그려보는 우리 엄마 아빠의 얼굴.',
  },
  {
    id: 3,
    src: '/images/Kids/soapyWater.jpg',
    alt: 'list-img',
    title: '버블 버블 세상',
    rate: '1.7',
    intro: '후~후~ 비눗방울을 불어보아요!',
  },
  {
    id: 4,
    src: '/images/Kids/handPainting.JPG',
    alt: 'list-img',
    title: '손바닥 놀이',
    rate: '4.5',
    intro: '물감을 찍어 철푸덕 철푸덕! 우리아이 촉감놀이를 해보아요.',
  },
  {
    id: 5,
    src: '/images/Kids/sandCastle.jpg',
    alt: 'list-img',
    title: '마법의 모래성',
    rate: '5.0',
    intro: '룰루랄라~ 엇? 저건? 마법의 모래성이잖아!',
  },
  {
    id: 6,
    src: '/images/Kids/rainbow.jpg',
    alt: 'list-img',
    title: '레인보우',
    rate: '3.1',
    intro: '우리 아이 손에서 빚어지는 아름다운 무지개, 함께 해봐요!',
  },
  {
    id: 7,
    src: '/images/Kids/ball.jpg',
    alt: 'list-img',
    title: '알록달록 세상',
    rate: '2.8',
    intro: '알록달록 요술공에 숨어있는 요정은?',
  },
  {
    id: 8,
    src: '/images/Kids/jump.jpg',
    alt: 'list-img',
    title: '점핑 점핑 업!',
    rate: '4.8',
    intro: '점프! 누가 제일 멀리 높이 높이 뛰나 대결해보아요!',
  },
  {
    id: 9,
    src: '/images/Kids/play.JPG',
    alt: 'list-img',
    title: '플레이, 플레이, 플레이',
    rate: '1.7',
    intro: '노는게 제일 좋아!',
  },
  {
    id: 10,
    src: '/images/Kids/marvel.jpg',
    alt: 'list-img',
    title: '히어로가 될래요!',
    rate: '2.4',
    intro: '다양한 가면을 쓰고 히어로가 된 우리 아이!',
  },
  {
    id: 11,
    src: '/images/Kids/swing.jpg',
    alt: 'list-img',
    title: '같이 그네 탈래?',
    rate: '2.7',
    intro: '날아라 그네야~ 누가 누가 하늘까지 닿나 시합해보자~!',
  },
  {
    id: 12,
    src: '/images/Kids/children.jpg',
    alt: 'list-img',
    title: '칠드런 인 더 파크',
    rate: '3.5',
    intro: '따뜻한 봄날, 공원에서 벌어지는 아이들의 놀이 세상!',
  },
];
